import { render, staticRenderFns } from "./PreferenceSettingsComponent.vue?vue&type=template&id=3ba9fbbe&scoped=true"
import script from "./PreferenceSettingsComponent.vue?vue&type=script&lang=js"
export * from "./PreferenceSettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./PreferenceSettingsComponent.vue?vue&type=style&index=0&id=3ba9fbbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba9fbbe",
  null
  
)

export default component.exports